<div #menuItems class="menu-items skeleton-wrapper flex-row full-width" [class.skeleton]="loadingProperties?.isLoading" [@fadeIn]="loadingProperties?.isLoading">
  <div #chipsDivider>
    <mat-divider vertical *ngIf="chips?.length > 0" class="vertical-divider"></mat-divider>
  </div>
  <div #chipContainer class="chips flex-row">
    <vdw-input-chip #chips *ngFor="let chip of chips; let index = index" class="chip" [value]="chip.value" [route]="chip.url"></vdw-input-chip>
  </div>
  <div #productionScheduleProgress class="production-schedule-progress">
    <app-production-schedule-progress
      [productionSchedulePhase]="productionSchedulePhase"
      (clickEvent)="onProductionSchedulePhaseClicked($event)"
      [isScheduleCompleted]="canShowProperties?.canShowDecreatedButton"
      [areAllFieldsDisabled]="areAllFieldsDisabled"
    ></app-production-schedule-progress>
  </div>

  <div #phaseDivider>
    <mat-divider vertical class="vertical-divider"></mat-divider>
  </div>

  <div class="flex-end-center header-actions">
    <vdw-dialog-button #customSettingsButton (dialogDataChanged)="onOptionChanged($event)" [componentType]="pathContentSettingsDialogComponent" [dialogData]="getDialogData()">
      <button
        mat-icon-button
        class="mat-icon-action-button-lg-with-border"
        [class.open]="customSettingsButton.open"
        (click)="customSettingsButton.toggleDialog()"
        [matTooltip]="'GENERAL.CUSTOM_SETTINGS.CUSTOM_SETTINGS' | bmsTranslate"
      >
        <mat-icon svgIcon="settings"></mat-icon>
      </button>
    </vdw-dialog-button>
  </div>

  <div #phaseDivider>
    <mat-divider vertical class="vertical-divider"></mat-divider>
  </div>

  <div #actions class="actions flex-row">
    <vdw-invalid-form-message *ngIf="canShowProperties?.canShowInvalidFormMessageError" [message]="customErrorMessage"></vdw-invalid-form-message>
    <vdw-invalid-form-message *ngIf="waitingForInitialZonesToLoad()" [message]="INITIAL_DATA_NOT_LOADED_TRANSLATION_KEY"></vdw-invalid-form-message>

    <div *ngIf="canShowToPreselectionButton()" class="button-skeleton-wrapper standard-btn">
      <vdw-progress-button
        label="PRODUCTION_ORDER.NAVIGATION.TO_PRESELECTION"
        [raisedButton]="false"
        [inProgress]="loadingProperties?.preselectionLoading"
        (progressClick)="toPreselectionClicked()"
      ></vdw-progress-button>
    </div>

    <vdw-progress-button
      label="PRODUCTION_ORDER.ACTIONS.DECREATE"
      *ngIf="canShowProperties?.canShowDecreatedButton"
      [inProgress]="loadingProperties?.decreateLoading"
      (progressClick)="decreateClicked()"
    ></vdw-progress-button>

    <div *ngIf="canShowProperties?.canShowCancelButton || areAllFieldsDisabled">
      <vdw-progress-button label="GENERAL.ACTIONS.CANCEL" [inProgress]="loadingProperties?.completeLoading" [raisedButton]="false" (progressClick)="cancelClicked()"></vdw-progress-button>
    </div>

    <div *ngIf="canShowProperties?.canShowNavigateToNextPhaseButton" class="button-skeleton-wrapper">
      <vdw-progress-button [label]="getLabelForNextButton()" [inProgress]="loadingProperties?.nextPhaseLoading" [raisedButton]="isRaisedButton()" (progressClick)="nextPhaseClicked()">
      </vdw-progress-button>
    </div>

    <div *ngIf="canShowSaveMenuTrigger()" class="button-skeleton-wrapper raised-btn">
      <vdw-progress-button [label]="getLabelForSaveButton()" [inProgress]="loadingProperties?.nextPhaseLoading" [hasIcon]="canShowSaveMenuTrigger()" (progressClick)="save()">
        <div
          #saveMenuTrigger
          *ngIf="canShowSaveMenuTrigger()"
          class="full-height flex-center verify-menu-trigger"
          [class.hide-icon]="loadingProperties?.nextPhaseLoading"
          [matMenuTriggerFor]="saveMenu"
          (click)="$event.stopPropagation()"
          (mouseenter)="mouseEnterSaveButton()"
          (mouseleave)="mouseLeaveSaveButton()"
        >
          <mat-icon svgIcon="chevron-down"></mat-icon>
        </div>
      </vdw-progress-button>
    </div>

    <vdw-progress-button
      label="PRODUCTION_ORDER.OVERVIEW.COMPLETE"
      *ngIf="canShowProperties?.canShowCompleteButton"
      [inProgress]="loadingProperties?.completeLoading"
      (progressClick)="completeClicked()"
    ></vdw-progress-button>
  </div>
</div>

<mat-menu #saveMenu="matMenu" yPosition="below" class="mat-elevation-z0" [hasBackdrop]="false">
  <div (mouseenter)="mouseEnterSaveButton()" (mouseleave)="mouseLeaveSaveButton()">
    <button *ngIf="hasSaveMenuButton()" mat-menu-item (click)="save(SAVE_TYPE)">{{ SAVE | bmsTranslate }}</button>
    <button *ngIf="hasSaveAndCreateNewMenuButton()" mat-menu-item class="button-skeleton-wrapper" (click)="save(SAVE_AND_CREATE_NEW_TYPE)">
      {{ SAVE_AND_CREATE_NEW | bmsTranslate }}
    </button>
    <button *ngIf="hasSaveAndGoToPreselectionMenuButton()" mat-menu-item class="button-skeleton-wrapper" (click)="save(SAVE_AND_GO_TO_PRESELECTION_TYPE)">
      {{ SAVE_AND_GO_TO_PRESELECTION | bmsTranslate }}
    </button>
    <button *ngIf="hasSaveAndQuitMenuButton()" mat-menu-item class="button-skeleton-wrapper" (click)="save(SAVE_AND_QUIT_TYPE)">
      {{ SAVE_AND_QUIT | bmsTranslate }}
    </button>
  </div>
</mat-menu>
